import { render, staticRenderFns } from "./account-switcher.vue?vue&type=template&id=57025929&scoped=true&"
import script from "./account-switcher.vue?vue&type=script&lang=js&"
export * from "./account-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57025929",
  null
  
)

export default component.exports